export const TOP_AND_BOTTOM_ANCHORS = ['SCROLL_TO_TOP', 'SCROLL_TO_BOTTOM']
